import React, { useRef, useState, useEffect } from "react";
import { downloadReport } from "../../../assets/images";
import { UiButton, UiSearch, UiRangePicker, UiTable, UiTab, SubmerchantModal } from "../../../components";
import { lang_en_US as translation } from "../../../config";
import { ACCOUNT_REQUEST_HEADER_COLUMNS, LAWYER_EDITABLE_FIELDS, LAWYER_REQUEST_HEADER_COLUMNS, tabData } from "./config";
import "./style.scss"
import "../lawyer/style.scss"
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { loaderReducer } from "../../../reducer/loader.reducer";
import * as api from "../../../actions";
import { apiServices } from "../../../apiServices/interceptor";
import { ACCOUNT_DETAILS, LAWYERMANAGEMENT } from "../../../apiServices/endpoints";
import BankDetailsModal from "../lawyer/BankDetailsModal";
import AllRequestReport from "./reports/allRequestReport";
import dayjs from "dayjs";
import { searchInitiateDelayTime, tablePageSizeOptions, downloadFile, exportAdvocateReportToExcel } from "../../../utils/appUtils";
import ViewDoc from "./viewdoc";
import LawyerProfileView from "./LawyerProfileView";
import EditRequestCompareDrawer from "./EditRequestCompareDrawer";
import ApproveAccountModal from "./ApproveAccountModal";
import { showSuccessNotification, showErrorNotification } from "../../../components/uiNotification";
import { DatePicker } from "antd";

const PrintAllRequestReport = React.forwardRef((props, ref) => {
    return <div ref={ref}>
        <AllRequestReport data={props?.data} date={props?.date} selectedMonth={props?.selectedMonth} selectedMonthString={props?.selectedMonthString} />
    </div>
});

const INITIAL_REQUEST_FILTER = {
    activeTabKey: "1",
    page: 0,
    size: 10,
    fromDate: "",
    toDate: "",
    month: null,
    searchTermValue: "",
    isReportOpen: false
};

const Requests = () => {
    const keywords = translation?.lawyerManagement;
    const userId = sessionStorage.getItem("userId");
    const reportRef = useRef(null);
    const lawyerProfileReportRef = useRef(null);
    const dispatch = useDispatch();
    const configResults = useSelector((state) => state?.configAction?.configData);
    const toemailaddress = configResults?.find((detail) => detail?.configId === "advLabelToAddress")?.configuration?.map((config) => ({ key: config, value: config }));
    const ccemailaddress = configResults?.find((detail) => detail?.configId === "advLabelCcAddress")?.configuration?.map((config) => ({ key: config, value: config }));
    const debounceTimeOut = useRef(null);
    const lawyerProfileImageUrlRef = useRef(null);
    const queryClient = useQueryClient();
    const [requestData, setRequestData] = useState([]);
    const [selectedLawyerIds, setSelectedLawyerIds] = useState([]);
    const [selectedLawyerRecords, setSelectedLawyerRecords] = useState([]);
    const [showCheckbox, setShowCheckbox] = useState(false);
    const [isSubmerchantModalOpen, setIsSubmerchantModalOpen] = useState(false);
    const [bankDetailsModal, setBankDetailsModal] = useState({
        open: false,
        loading: false,
        data: null
    });
    const [totalElements, setTotalElements] = useState(0);
    const [requestFilter, setRequestFilter] = useState(INITIAL_REQUEST_FILTER);
    const [isViewDocOpen, setIsViewDocOpen] = useState(false);
    const [isProfileViewOpen, setIsProfileViewOpen] = useState(false);
    const [selectedLawyer, setSelectedLawyer] = useState(null);
    const [documents, setDocuments] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [docLoading, setDocLoading] = useState(false);
    const [actionModalType, setActionModalType] = useState("");
    const [isProfileReportOpen, setIsProfileReportOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [approvePayload, setApprovePayload] = useState(null);
    const [rejectPayload, setRejectPayload] = useState(null);
    const [profileModalOpen, setProfileModalOpen] = useState(false);
    const [lawyerProfileImageUrl, setLawyerProfileImageUrl] = useState(null);
    const [isEditRequestCompareOpen, setIsEditRequestCompareOpen] = useState(false);
    const [selectedEditRequest, setSelectedEditRequest] = useState(null);
    const [editRequestComparisonData, setEditRequestComparisonData] = useState({ currentLawyerDetails: {}, requestedLawyerDetails: {} });
    const selectedMonthString = requestFilter?.month ? dayjs(requestFilter?.month).format("YYYY-MM") : "";
    const isEditRequestTab = requestFilter?.activeTabKey === "2";
    const isAccountRequestTab = requestFilter?.activeTabKey === "3";
    const isRejectModalOpen = actionModalType === "reject";
    const isApproveModalOpen = actionModalType === "approve";
    const [accountApproveModal, setAccountApproveModal] = useState({
        open: false,
        loading: false,
        record: null
    });
    const updateRequestFilter = (updatedFilterValues) => {
        setRequestFilter((prevFilter) => ({
            ...prevFilter,
            ...updatedFilterValues
        }));
    };

    const getRequestDetails = (isEditRequest, page, size, dateRange, selectedMonthString, searchTermValue) => api.get(`${LAWYERMANAGEMENT}/page?${isEditRequest ? "" : "approvalStatus=PENDING&"}page=${page}&size=${size}${isEditRequest ? `&isEditRequest=true` : ""}${dateRange?.fromDate && dateRange?.toDate ? `&stateDate=${dateRange.fromDate}&endDate=${dateRange.toDate}` : ""}${selectedMonthString ? `&month=${selectedMonthString}` : ""}${searchTermValue ? `&commonSearch=${searchTermValue}` : ""}`);
    const getAccountDetailsRequests = (page, size) => api.get(`${ACCOUNT_DETAILS}/lawyer/get_account_details?page=${page}&size=${size}&isChanged=true`);
    const getLawyerProfileDetails = (lawyerId) => api.get(`${LAWYERMANAGEMENT}/${lawyerId}`);
    const getLawyerRevisedDetails = (revisedLawyerDetailId) => api.get(`${LAWYERMANAGEMENT}/get_lawyer_revised_details/${revisedLawyerDetailId}`);
    const getLawyerAccountDetails = (id) => api.get(`${ACCOUNT_DETAILS}/lawyer/${id}`);
    const getDecryptedAccountNumber = (encryptedValue) => api.get(`${ACCOUNT_DETAILS}/decrypt_account_details/${encodeURIComponent(encryptedValue)}`);
    const approveLawyer = (lawyerId, approvalData) => api.post(`${LAWYERMANAGEMENT}/approval_lawyer/${lawyerId}`, approvalData);
    const rejectLawyer = (lawyerId, rejectionData) => api.post(`${LAWYERMANAGEMENT}/approval_lawyer/${lawyerId}`, rejectionData);
    const approveEditRequest = (lawyerId, payload) => api.put(`${LAWYERMANAGEMENT}/approve_edit_request/${lawyerId}`, payload);
    const updateAccountDetailsChanged = (lawyerId) => api.post(`${ACCOUNT_DETAILS}/update_account_details_changed?lawyerId=${encodeURIComponent(lawyerId)}`, {});

    const handlePrint = useReactToPrint({
        content: () => reportRef?.current,
        onAfterPrint: () => {
            updateRequestFilter({ isReportOpen: false, size: INITIAL_REQUEST_FILTER?.size });
        },
        pageStyle: `
            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        `
    });

    const handlePrintLawyerProfile = useReactToPrint({
        content: () => lawyerProfileReportRef?.current,
        onAfterPrint: () => setIsProfileReportOpen(false),
        pageStyle: `
            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        `
    });

    const { isFetching: isFetchingRequests, refetch: refetchAllRequests } = useQuery(
        ["FETCH_ALL_REQUESTS", requestFilter?.activeTabKey, requestFilter?.page, requestFilter?.size, requestFilter?.fromDate, requestFilter?.toDate, selectedMonthString, requestFilter?.searchTermValue],
        () => {
            if (isAccountRequestTab) {
                return getAccountDetailsRequests(requestFilter?.page, requestFilter?.size);
            }
            return getRequestDetails(
                requestFilter?.activeTabKey === "2",
                requestFilter?.page,
                requestFilter?.size,
                { fromDate: requestFilter?.fromDate, toDate: requestFilter?.toDate },
                selectedMonthString,
                requestFilter?.searchTermValue
            );
        },
        {
            onSuccess: async (response) => {
                if (response?.statusCode === 200) {
                    if (isAccountRequestTab) {
                        const content = response?.result?.accountDetails?.content || [];
                        const total = response?.result?.accountDetails?.totalElements || 0;
                        setRequestData(content);
                        setTotalElements(total);
                        if (content.length > 0) {
                            try {
                                const enriched = await Promise.all(
                                    content.map(async (item) => {
                                        if (!item?.lawyerId) return item;
                                        try {
                                            const lawyerRes = await getLawyerProfileDetails(item.lawyerId);
                                            if (lawyerRes?.statusCode === 200 && lawyerRes?.result?.lawyerDetails) {
                                                return {
                                                    ...item,
                                                    lawyerDetails: lawyerRes.result.lawyerDetails
                                                };
                                            }
                                        } catch (_) { }
                                        return item;
                                    })
                                );
                                setRequestData(enriched);
                            } catch (_) { }
                        }
                    } else {
                        setRequestData(response?.result?.lawyerDetails?.content || []);
                        setTotalElements(response?.result?.lawyerDetails?.totalElements || 0);
                    }
                } else {
                    setRequestData([]);
                    setTotalElements(0);
                }
            },
            refetchOnWindowFocus: false
        }
    );

    const { isFetching: isFetchingLawyerProfile } = useQuery(
        ["FETCH_LAWYER_PROFILE", selectedLawyer?.lawyerId],
        () => getLawyerProfileDetails(selectedLawyer?.lawyerId),
        {
            onSuccess: (response) => {
                if (response?.statusCode === 200 && response?.result?.lawyerDetails) {
                    const lawyerDetails = response?.result?.lawyerDetails;
                    const mappedData = {
                        ...lawyerDetails,
                        lawyerName: `${lawyerDetails?.firstName || ""} ${lawyerDetails?.middleName || ""} ${lawyerDetails?.lastName || ""}`.trim(),
                        phone: lawyerDetails?.mobileNumber,
                        barId: lawyerDetails?.barCouncilId,
                        specializations: lawyerDetails?.specialization,
                        about: lawyerDetails?.aboutAs,
                        profileUrl: lawyerDetails?.profileUrl,
                        rejectedReason: lawyerDetails?.approvalInfo?.rejectionReason,
                    };
                    const docUrlData = lawyerDetails?.documentUrl;
                    let fetchedDocuments = [];
                    const documentNameMapping = {
                        proofdoc: "Proof Document",
                        aadharfrontsidedoc: "Aadhar Front Side",
                        aadharbacksidedoc: "Aadhar Back Side",
                        pancarddoc: "Pan Card",
                        checklistdoc: "Checklist",
                        aadhaarFront: "Aadhar Front Side",
                        aadhaarBack: "Aadhar Back Side",
                        panCard: "Pan Card",
                        checkLeaf: "Check Leaf",
                        professionalCertificate: "Professional Certificate",
                        proofUrl: "Proof Document",
                        teamsAndConditions: "Terms and Condition",
                        termsAndConditions: "Terms and Condition",
                        teamsAndCondition: "Terms and Condition",
                        termsAndCondition: "Terms and Condition",
                        termsandconditions: "Terms and Condition",
                        teamsandconditions: "Terms and Condition",
                        termscondition: "Terms and Condition",
                        teamscondition: "Terms and Condition",
                        terms: "Terms and Condition"
                    };
                    const resolveDocName = (keyOrUrl, index) => {
                        if (!keyOrUrl) return `Document ${index + 1}`;
                        if (documentNameMapping[keyOrUrl]) return documentNameMapping[keyOrUrl];
                        const cleanStr = String(keyOrUrl).toLowerCase();
                        for (const [key, label] of Object.entries(documentNameMapping)) {
                            if (cleanStr.includes(key.toLowerCase())) {
                                return label;
                            }
                        }
                        if ((cleanStr.includes("team") || cleanStr.includes("term")) && cleanStr.includes("condition")) {
                            return "Terms and Condition";
                        }
                        const fileName = String(keyOrUrl).split('/').pop();
                        return fileName || `Document ${index + 1}`;
                    };
                    if (docUrlData) {
                        if (Array.isArray(docUrlData)) {
                            fetchedDocuments = docUrlData
                                .filter(Boolean)
                                .map((docUrl, index) => ({
                                    id: docUrl,
                                    name: resolveDocName(docUrl, index),
                                    url: docUrl.startsWith('/file/file-document') ? `${LAWYERMANAGEMENT}${docUrl}` : `${LAWYERMANAGEMENT}/file${docUrl}`,
                                    type: docUrl.split('.').pop() || 'pdf',
                                    uploadDate: new Date().toLocaleDateString()
                                }));
                        } else if (typeof docUrlData === "object") {
                            fetchedDocuments = Object.entries(docUrlData)
                                .filter(([_, docUrl]) => Boolean(docUrl))
                                .map(([key, docUrl], index) => ({
                                    id: docUrl,
                                    name: documentNameMapping[key] || resolveDocName(key || docUrl, index),
                                    url: docUrl.startsWith('/file/file-document') ? `${LAWYERMANAGEMENT}${docUrl}` : `${LAWYERMANAGEMENT}/file${docUrl}`,
                                    type: docUrl.split('.').pop() || 'pdf',
                                    uploadDate: new Date().toLocaleDateString()
                                }));
                        }
                    }
                    setDocuments(fetchedDocuments);
                    if (fetchedDocuments.length > 0) {
                        setSelectedDocument(fetchedDocuments[0]);
                    }
                    setSelectedLawyer(mappedData);
                    setIsProfileViewOpen(true);
                } else {
                    setIsProfileViewOpen(true);
                }
            },
            enabled: !!selectedLawyer?.lawyerId && !selectedLawyer?.isViewingDocOnly,
            refetchOnWindowFocus: false
        }
    );

    const { isFetching: isFetchingEditRequestCompare } = useQuery(
        ["FETCH_EDIT_REQUEST_COMPARE", selectedEditRequest?.lawyerId, selectedEditRequest?.revisedLawyerDetailId],
        () => Promise.all([
            getLawyerProfileDetails(selectedEditRequest?.lawyerId),
            getLawyerRevisedDetails(selectedEditRequest?.revisedLawyerDetailId)
        ]),
        {
            onSuccess: (responses) => {
                const currentResponse = responses?.[0];
                const revisedResponse = responses?.[1];
                if (currentResponse?.statusCode === 200 && currentResponse?.result?.lawyerDetails) {
                    setEditRequestComparisonData({
                        currentLawyerDetails: currentResponse?.result?.lawyerDetails || {},
                        requestedLawyerDetails: revisedResponse?.result?.lawyerDetails || {}
                    });
                }
            },
            enabled: Boolean(isEditRequestCompareOpen && selectedEditRequest?.lawyerId && selectedEditRequest?.revisedLawyerDetailId),
            refetchOnWindowFocus: false
        }
    );

    const { isFetching: isApproveLoading, refetch: refetchApproveLawyer } = useQuery(
        ["APPROVE_LAWYER", approvePayload?.lawyerId],
        () => {
            if (approvePayload?.isEditRequest) {
                return approveEditRequest(approvePayload?.lawyerId, approvePayload?.approvalData);
            }
            return approveLawyer(approvePayload?.lawyerId, approvePayload?.approvalData);
        },
        {
            onSuccess: (response) => {
                if (response?.data?.statusCode === 200) {
                    refetchAllRequests();
                    setIsProfileViewOpen(false);
                    setIsEditRequestCompareOpen(false);
                    setSelectedLawyer(null);
                    setSelectedEditRequest(null);
                    setEditRequestComparisonData({ currentLawyerDetails: {}, requestedLawyerDetails: {} });
                    setActionModalType("");
                    setApprovePayload(null);
                    showSuccessNotification("Success", 'Advocate approved successfully');
                } else {
                    showErrorNotification("Error", response?.response?.data?.error?.message || 'Error approving advocate');
                }
            },
            enabled: false,
            refetchOnWindowFocus: false
        }
    );

    const { isFetching: isRejectLoading, refetch: refetchRejectLawyer } = useQuery(
        ["REJECT_LAWYER", rejectPayload?.lawyerId],
        () => {
            if (rejectPayload?.isEditRequest) {
                return approveEditRequest(rejectPayload?.lawyerId, rejectPayload?.rejectionData);
            }
            return rejectLawyer(rejectPayload?.lawyerId, rejectPayload?.rejectionData);
        },
        {
            onSuccess: (response) => {
                if (response?.data?.statusCode === 200) {
                    refetchAllRequests();
                    setIsProfileViewOpen(false);
                    setIsEditRequestCompareOpen(false);
                    setSelectedLawyer(null);
                    setSelectedEditRequest(null);
                    setEditRequestComparisonData({ currentLawyerDetails: {}, requestedLawyerDetails: {} });
                    setActionModalType("");
                    setRejectPayload(null);
                    showSuccessNotification("Success", 'Advocate rejected successfully');
                } else {
                    showErrorNotification("Error", response?.response?.data?.error?.message || 'Error rejecting advocate');
                }
            },
            enabled: false,
            refetchOnWindowFocus: false
        }
    );

    const handleReportDownload = (params = null) => {
        if (isEditRequestTab) {
            return;
        }
        updateRequestFilter({ size: -1, isReportOpen: true });
    };

    const handleReasonChange = (event) => {
        setReason(event.target.value);
    };

    const handleProfileModalOpen = () => {
        setProfileModalOpen(true);
    };

    const handleProfileModalClose = () => {
        setProfileModalOpen(false);
    };

    const handleDateChange = (dates) => {
        if (dates && dates.length === 2) {
            const fromDate = dayjs(dates?.[0]).format('YYYY-MM-DD');
            const toDate = dayjs(dates?.[1]).format('YYYY-MM-DD');
            if (fromDate && toDate) {
                updateRequestFilter({
                    fromDate: fromDate,
                    toDate: toDate,
                    month: null
                });
            }
        } else {
            updateRequestFilter({ fromDate: "", toDate: "" });
        }
    };

    const debounceSearch = (event) => {
        const searchTerm = event?.target?.value || "";
        if (debounceTimeOut?.current) {
            clearTimeout(debounceTimeOut?.current);
        }
        if (searchTerm !== "") {
            debounceTimeOut.current = setTimeout(() => {
                updateRequestFilter({ searchTermValue: searchTerm, page: 0 });
            }, searchInitiateDelayTime);
        } else {
            updateRequestFilter({ searchTermValue: "", page: 0 });
        }
    };

    const handleMonthChange = (month) => {
        if (month) {
            updateRequestFilter({ month: month, fromDate: "", toDate: "" });
        } else {
            updateRequestFilter({ month: null });
        }
    };

    const handlePagination = (page, size) => {
        updateRequestFilter({ page: page - 1, size: size });
    };

    const handleTabChanges = (key) => {
        const selectedTab = tabData?.find((tab) => tab?.key === key);
        if (selectedTab?.content) {
            setRequestFilter({
                ...INITIAL_REQUEST_FILTER,
                activeTabKey: key,
            });
            setSelectedLawyerIds([]);
            setSelectedLawyerRecords([]);
            setShowCheckbox(false);
        }
    };

    const handleSelectLawyer = (lawyerId, record) => {
        setSelectedLawyerIds(prev => {
            if (prev.includes(lawyerId)) {
                return prev.filter(id => id !== lawyerId);
            } else {
                return [...prev, lawyerId];
            }
        });
        setSelectedLawyerRecords(prev => {
            const exists = prev.some(item => (item?.lawyerId || item?.id || item?.requestId) === lawyerId);
            if (exists) {
                return prev.filter(item => (item?.lawyerId || item?.id || item?.requestId) !== lawyerId);
            } else {
                return [...prev, record];
            }
        });
    };

    const handleSelectAll = (checked) => {
        const currentVisibleIds = (requestData || []).map(item => item?.lawyerId || item?.id || item?.requestId).filter(Boolean);
        if (checked) {
            setSelectedLawyerIds(prev => Array.from(new Set([...prev, ...currentVisibleIds])));
            setSelectedLawyerRecords(prev => {
                const map = new Map(prev.map(item => [item?.lawyerId || item?.id || item?.requestId, item]));
                (requestData || []).forEach(item => {
                    const id = item?.lawyerId || item?.id || item?.requestId;
                    if (id) map.set(id, item);
                });
                return Array.from(map.values());
            });
        } else {
            setSelectedLawyerIds(prev => prev.filter(id => !currentVisibleIds.includes(id)));
            setSelectedLawyerRecords(prev => prev.filter(item => !currentVisibleIds.includes(item?.lawyerId || item?.id || item?.requestId)));
        }
    };

    const handleOpenExcelModal = () => {
        if (selectedLawyerIds?.length === 0) {
            showErrorNotification("Warning", "Please select at least one advocate to download report.");
            return;
        }
        setIsSubmerchantModalOpen(true);
    };

    const handleDownloadExcelReport = async (submerchantMap = {}, emailDetails = {}) => {
        if (selectedLawyerIds?.length === 0) {
            showErrorNotification("Warning", "Please select at least one advocate to download report.");
            return;
        }

        dispatch(loaderReducer(true));
        try {
            const recordsToExport = await Promise.all(selectedLawyerIds.map(async (id) => {
                const foundRecord = selectedLawyerRecords.find(item => (item?.lawyerId || item?.id || item?.requestId) === id)
                    || requestData.find(item => (item?.lawyerId || item?.id || item?.requestId) === id)
                    || { id };

                const key = foundRecord?.lawyerId || foundRecord?.id || foundRecord?.requestId || foundRecord?.lawyerNo || id;
                const subDetails = submerchantMap?.[key] || submerchantMap?.[id] || submerchantMap?.[foundRecord?.lawyerNo] || {};

                let primaryBank = null;
                const existingBank = foundRecord?.bankDetails;
                if (existingBank && (Array.isArray(existingBank) ? existingBank.length > 0 : Boolean(existingBank?.accountNumber || existingBank?.encryptAccountNumber || existingBank?.bankName))) {
                    const bankList = Array.isArray(existingBank) ? existingBank : [existingBank];
                    primaryBank = bankList.find((item) => item?.primary) || bankList[0];
                }
                if (!primaryBank || !primaryBank?.bankName || (primaryBank?.encryptAccountNumber && !primaryBank?.decryptAccountNumber)) {
                    try {
                        const accountRes = await getLawyerAccountDetails(id);
                        if (accountRes?.statusCode === 200 && accountRes?.result) {
                            const fetchedBankList = accountRes?.result?.lawyerDetailResponse?.bankDetails || accountRes?.result?.bankDetails || [];
                            const fetchedPrimary = Array.isArray(fetchedBankList)
                                ? (fetchedBankList.find((item) => item?.primary) || fetchedBankList[0])
                                : fetchedBankList;
                            if (fetchedPrimary) {
                                primaryBank = { ...fetchedPrimary };
                            }
                        }
                    } catch (err) {
                        console.error("Error fetching account details for lawyer in request:", id, err);
                    }
                }
                if (primaryBank?.encryptAccountNumber && !primaryBank?.decryptAccountNumber) {
                    try {
                        const decryptRes = await getDecryptedAccountNumber(primaryBank.encryptAccountNumber);
                        let decryptedAccountNumber = "";
                        if (decryptRes?.result?.decrypted) {
                            decryptedAccountNumber = decryptRes.result.decrypted;
                        } else if (typeof decryptRes?.result === "string") {
                            decryptedAccountNumber = decryptRes.result;
                        } else if (decryptRes?.result?.accountNumber || decryptRes?.result?.decryptAccountNumber) {
                            decryptedAccountNumber = decryptRes.result.accountNumber || decryptRes.result.decryptAccountNumber;
                        } else if (decryptRes?.data?.decrypted) {
                            decryptedAccountNumber = decryptRes.data.decrypted;
                        } else if (typeof decryptRes?.data === "string") {
                            decryptedAccountNumber = decryptRes.data;
                        } else if (decryptRes?.data?.accountNumber || decryptRes?.data?.decryptAccountNumber) {
                            decryptedAccountNumber = decryptRes.data.accountNumber || decryptRes.data.decryptAccountNumber;
                        } else if (decryptRes?.result) {
                            decryptedAccountNumber = String(decryptRes.result);
                        }

                        if (decryptedAccountNumber) {
                            primaryBank = {
                                ...primaryBank,
                                decryptAccountNumber: decryptedAccountNumber,
                                accountNumber: decryptedAccountNumber
                            };
                        }
                    } catch (err) {
                        console.error("Error decrypting account number for request:", id, err);
                    }
                }

                return {
                    ...foundRecord,
                    submerchantId: subDetails?.submerchantId || "",
                    bankDetails: primaryBank ? [primaryBank] : (foundRecord?.bankDetails || null)
                };
            }));

            const fileName = `Advocate_Request_Report_${dayjs().format("YYYY-MM-DD_HH-mm")}`;
            exportAdvocateReportToExcel(
                recordsToExport,
                fileName,
                isAccountRequestTab ? "ACCOUNT_REQUEST" : isEditRequestTab ? "EDIT_REQUEST" : "REQUEST",
                emailDetails
            );
            setIsSubmerchantModalOpen(false);
            showSuccessNotification("Success", emailDetails?.toEmail ? "Advocate report downloaded and email composer opened successfully." : "Advocate report downloaded successfully.");
        } catch (error) {
            console.error("Failed to export request report:", error);
            showErrorNotification("Error", "Failed to download advocate report. Please try again.");
        } finally {
            dispatch(loaderReducer(false));
        }
    };

    const handleRequestLabel = () => {
        setShowCheckbox(true);
    };

    const handleCancelRequestLabel = () => {
        setShowCheckbox(false);
        setSelectedLawyerIds([]);
        setSelectedLawyerRecords([]);
    };

    const { isFetching: isFetchingAccountDetails } = useQuery(["FETCH_ACCOUNT_DETAILS_REQUEST", ""], getLawyerAccountDetails, {
        onSuccess: (accountResponse) => {
            if (accountResponse?.statusCode === 200 && accountResponse?.result) {
                const bankList = accountResponse?.result?.lawyerDetailResponse?.bankDetails || accountResponse?.result?.bankDetails || [];
                const primaryBank = Array.isArray(bankList)
                    ? (bankList.find((item) => item?.primary) || bankList[0])
                    : (bankList || null);

                if (primaryBank) {
                    if (primaryBank?.encryptAccountNumber && !primaryBank?.decryptAccountNumber) {
                        setBankDetailsModal(prev => ({
                            ...prev,
                            loading: true,
                            data: primaryBank
                        }));
                        queryClient.prefetchQuery(["FETCH_DECRYPT_ACCOUNT_REQUEST", ""], () => getDecryptedAccountNumber(primaryBank.encryptAccountNumber));
                        return;
                    }

                    setBankDetailsModal({
                        open: true,
                        loading: false,
                        data: primaryBank
                    });
                    return;
                }
            }

            setBankDetailsModal(prev => ({
                open: true,
                loading: false,
                data: prev?.data || null
            }));
        },
        onError: () => {
            setBankDetailsModal(prev => ({
                open: true,
                loading: false,
                data: prev?.data || null
            }));
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingDecryptAccount } = useQuery(["FETCH_DECRYPT_ACCOUNT_REQUEST", ""], getDecryptedAccountNumber, {
        onSuccess: (decryptResponse) => {
            const decryptedAccountNumber = decryptResponse?.result?.decrypted || "";

            setBankDetailsModal(prev => ({
                open: true,
                loading: false,
                data: {
                    ...prev?.data,
                    decryptAccountNumber: decryptedAccountNumber || prev?.data?.decryptAccountNumber || prev?.data?.accountNumber,
                    accountNumber: decryptedAccountNumber || prev?.data?.accountNumber
                }
            }));
        },
        onError: () => {
            setBankDetailsModal(prev => ({
                open: true,
                loading: false,
                data: prev?.data || null
            }));
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const handleBankDetails = (detail) => {
        const lawyerId = detail?.lawyerId || detail?.id || detail?.requestId;
        const fallbackBankData = detail?.bankDetails || detail;

        setBankDetailsModal({
            open: true,
            loading: Boolean(lawyerId && !detail?.bankDetails),
            data: fallbackBankData || null
        });

        if (lawyerId && !detail?.bankDetails) {
            queryClient.prefetchQuery(["FETCH_ACCOUNT_DETAILS_REQUEST", ""], () => getLawyerAccountDetails(lawyerId));
        }
    };

    const handleBankDetailsClose = () => {
        setBankDetailsModal({ open: false, loading: false, data: null });
    };

    const visibleIds = (requestData || []).map(item => item?.lawyerId || item?.id || item?.requestId).filter(Boolean);
    const isAllSelected = visibleIds.length > 0 && visibleIds.every(id => selectedLawyerIds.includes(id));
    const isIndeterminate = visibleIds.some(id => selectedLawyerIds.includes(id)) && !isAllSelected;

    const handleViewProfile = (record) => {
        if (isEditRequestTab) {
            setSelectedLawyer(null);
            setSelectedEditRequest({
                lawyerId: record?.lawyerId,
                revisedLawyerDetailId: record?.editRequest?.revisedLawyerDetailId
            });
            setIsEditRequestCompareOpen(true);
        } else if (isAccountRequestTab) {
            const lawyerId = record?.lawyerId;
            setSelectedLawyer(record?.lawyerDetails ? {
                ...record.lawyerDetails,
                lawyerId: lawyerId,
                bankDetails: record.bankDetails
            } : {
                lawyerId: lawyerId,
                bankDetails: record?.bankDetails
            });
        }
        else {
            setSelectedLawyer(record);
        }
    };

    const handleViewDoc = (record) => {
        const lawyerId = record?.lawyerId || record?.id || record?.requestId;
        setSelectedLawyer({
            ...record,
            lawyerId: lawyerId,
            isViewingDocOnly: true
        });
        setIsViewDocOpen(true);
    };

    const handleCloseViewDoc = () => {
        setIsViewDocOpen(false);
        setSelectedLawyer(null);
        setDocuments([]);
        setSelectedDocument(null);
        setDocLoading(false);
    };

    const handleDocumentSelect = (document) => {
        if (document) {
            setSelectedDocument(document);
        }
    };

    const handleDownload = async () => {
        if (!selectedDocument?.url) return;
        const downloadUrl = selectedDocument.url;
        const fileName = selectedDocument?.name || 'document.pdf';
        try {
            await downloadFile(downloadUrl, fileName);
            showSuccessNotification("Success", 'Document downloaded successfully');
        } catch (error) {
            showErrorNotification("Error", 'Failed to download document');
        }
    };

    const handleCloseProfileView = () => {
        setIsProfileViewOpen(false);
        setSelectedLawyer(null);
        setActionModalType("");
        setIsProfileReportOpen(false);
        setReason("");
        setDocuments([]);
        setSelectedDocument(null);
    };

    const handleCloseEditRequestCompare = () => {
        setIsEditRequestCompareOpen(false);
        setSelectedEditRequest(null);
        setEditRequestComparisonData({ currentLawyerDetails: {}, requestedLawyerDetails: {} });
        setActionModalType("");
        setProfileModalOpen(false);
        setReason("");
    };

    const handleApprove = (lawyerData) => {
        setApprovePayload({
            lawyerId: lawyerData?.lawyerId,
            isEditRequest: isEditRequestCompareOpen,
            approvalData: {
                approvalById: userId,
                approvalStatus: "APPROVED",
                approvalDate: dayjs().format('YYYY-MM-DD'),
                rejectedReason: ""
            }
        });
    };

    const handleReject = (lawyerData, rejectionReason) => {
        setRejectPayload({
            lawyerId: lawyerData?.lawyerId,
            isEditRequest: isEditRequestCompareOpen,
            rejectionData: {
                approvalById: userId,
                approvalStatus: "REJECTED",
                approvalDate: dayjs().format('YYYY-MM-DD'),
                rejectedReason: rejectionReason
            }
        });
    };

    const handleRejectClick = () => {
        setActionModalType("reject");
    };

    const handleApproveClick = () => {
        setActionModalType("approve");
    };

    const handleRejectSubmit = (reason) => {
        const selectedLawyerDetail = isEditRequestCompareOpen ? editRequestComparisonData?.currentLawyerDetails : selectedLawyer;
        handleReject(selectedLawyerDetail, reason);
    };

    const handleApproveConfirm = () => {
        const selectedLawyerDetail = isEditRequestCompareOpen ? editRequestComparisonData?.currentLawyerDetails : selectedLawyer;
        handleApprove(selectedLawyerDetail);
    };

    const handleCloseRejectModal = () => {
        setActionModalType("");
    };

    const handleCloseApproveModal = () => {
        setActionModalType("");
    };

    const handleAccountApproveClick = (record) => {
        setAccountApproveModal({
            open: true,
            loading: false,
            record
        });
    };

    const handleAccountApproveClose = () => {
        if (accountApproveModal.loading) return;
        setAccountApproveModal({
            open: false,
            loading: false,
            record: null
        });
    };

    const handleAccountApproveConfirm = async () => {
        const lawyerId = accountApproveModal?.record?.lawyerId || accountApproveModal?.record?.id;
        if (!lawyerId) {
            showErrorNotification("Error", "Lawyer ID not found");
            return;
        }
        try {
            setAccountApproveModal((prev) => ({ ...prev, loading: true }));
            const response = await updateAccountDetailsChanged(lawyerId);
            const resData = response?.data || response;
            const isSuccess = (response?.status >= 200 && response?.status < 300) || resData?.statusCode === 200 || response?.statusCode === 200;
            if (isSuccess) {
                showSuccessNotification("Success", resData?.message || response?.message || "Account changes approved successfully");
                setAccountApproveModal({ open: false, loading: false, record: null });
                refetchAllRequests();
            } else {
                const errorMsg = response?.response?.data?.error?.message 
                    || response?.response?.data?.message 
                    || resData?.error?.message 
                    || resData?.message 
                    || response?.message 
                    || "Error approving account changes";
                showErrorNotification("Error", errorMsg);
                setAccountApproveModal((prev) => ({ ...prev, loading: false }));
            }
        } catch (err) {
            const errorMsg = err?.response?.data?.error?.message || err?.response?.data?.message || err?.message || "Error approving account changes";
            showErrorNotification("Error", errorMsg);
            setAccountApproveModal((prev) => ({ ...prev, loading: false }));
        }
    };

    const handleDownloadReportClick = () => {
        setIsProfileReportOpen(true);
    };

    useEffect(() => {
        if (approvePayload) {
            refetchApproveLawyer();
        }
    }, [approvePayload, refetchApproveLawyer]);

    useEffect(() => {
        if (rejectPayload) {
            refetchRejectLawyer();
        }
    }, [rejectPayload, refetchRejectLawyer]);

    useEffect(() => {
        if (requestFilter?.isReportOpen) {
            handlePrint();
        }
    }, [requestFilter?.isReportOpen, handlePrint]);

    useEffect(() => {
        return () => {
            if (debounceTimeOut?.current) {
                clearTimeout(debounceTimeOut?.current);
            }
        };
    }, []);

    useEffect(() => {
        if (isViewDocOpen && selectedLawyer?.isViewingDocOnly && selectedLawyer?.lawyerId) {
            const fetchProfileAndDocuments = async () => {
                try {
                    setDocLoading(true);
                    const response = await getLawyerProfileDetails(selectedLawyer?.lawyerId);
                    if (response?.statusCode === 200 && response?.result?.lawyerDetails) {
                        const lawyerDetails = response?.result?.lawyerDetails;
                        const docUrlData = lawyerDetails?.documentUrl;
                        let fetchedDocuments = [];
                        const documentNameMapping = {
                            proofdoc: "Proof Document",
                            aadharfrontsidedoc: "Aadhar Front Side",
                            aadharbacksidedoc: "Aadhar Back Side",
                            pancarddoc: "Pan Card",
                            checklistdoc: "Checklist",
                            aadhaarFront: "Aadhar Front Side",
                            aadhaarBack: "Aadhar Back Side",
                            panCard: "Pan Card",
                            checkLeaf: "Check Leaf",
                            professionalCertificate: "Professional Certificate",
                            proofUrl: "Proof Document",
                            teamsAndConditions: "Terms and Condition",
                            termsAndConditions: "Terms and Condition",
                            teamsAndCondition: "Terms and Condition",
                            termsAndCondition: "Terms and Condition",
                            termsandconditions: "Terms and Condition",
                            teamsandconditions: "Terms and Condition",
                            termscondition: "Terms and Condition",
                            teamscondition: "Terms and Condition",
                            terms: "Terms and Condition"
                        };
                        const resolveDocName = (keyOrUrl, index) => {
                            if (!keyOrUrl) return `Document ${index + 1}`;
                            if (documentNameMapping[keyOrUrl]) return documentNameMapping[keyOrUrl];
                            const cleanStr = String(keyOrUrl).toLowerCase();
                            for (const [key, label] of Object.entries(documentNameMapping)) {
                                if (cleanStr.includes(key.toLowerCase())) {
                                    return label;
                                }
                            }
                            if ((cleanStr.includes("team") || cleanStr.includes("term")) && cleanStr.includes("condition")) {
                                return "Terms and Condition";
                            }
                            const fileName = String(keyOrUrl).split('/').pop();
                            return fileName || `Document ${index + 1}`;
                        };
                        if (docUrlData) {
                            if (Array.isArray(docUrlData)) {
                                fetchedDocuments = docUrlData
                                    .filter(Boolean)
                                    .map((docUrl, index) => ({
                                        id: docUrl,
                                        name: resolveDocName(docUrl, index),
                                        url: docUrl.startsWith('/file/file-document') ? `${LAWYERMANAGEMENT}${docUrl}` : `${LAWYERMANAGEMENT}/file${docUrl}`,
                                        type: docUrl.split('.').pop() || 'pdf',
                                        uploadDate: new Date().toLocaleDateString()
                                    }));
                            } else if (typeof docUrlData === "object") {
                                fetchedDocuments = Object.entries(docUrlData)
                                    .filter(([_, docUrl]) => Boolean(docUrl))
                                    .map(([key, docUrl], index) => ({
                                        id: docUrl,
                                        name: documentNameMapping[key] || resolveDocName(key || docUrl, index),
                                        url: docUrl.startsWith('/file/file-document') ? `${LAWYERMANAGEMENT}${docUrl}` : `${LAWYERMANAGEMENT}/file${docUrl}`,
                                        type: docUrl.split('.').pop() || 'pdf',
                                        uploadDate: new Date().toLocaleDateString()
                                    }));
                            }
                        }
                        setDocuments(fetchedDocuments);
                        setSelectedDocument(fetchedDocuments[0] || null);
                    }
                } catch (error) {
                } finally {
                    setDocLoading(false);
                }
            };
            fetchProfileAndDocuments();
        }
    }, [isViewDocOpen, selectedLawyer?.lawyerId, selectedLawyer?.isViewingDocOnly]);

    useEffect(() => {
        const profileUrl = isEditRequestCompareOpen ? editRequestComparisonData?.currentLawyerDetails?.profileUrl : selectedLawyer?.profileUrl;
        if (profileUrl && (isProfileViewOpen || isEditRequestCompareOpen)) {
            const fetchProfileImage = async () => {
                try {
                    const response = await apiServices.get(
                        `${LAWYERMANAGEMENT}/file${profileUrl}`,
                        { responseType: 'blob' }
                    );
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = URL.createObjectURL(blob);
                    setLawyerProfileImageUrl(url);
                    lawyerProfileImageUrlRef.current = url;
                } catch (error) {
                    setLawyerProfileImageUrl(null);
                    lawyerProfileImageUrlRef.current = null;
                }
            };
            fetchProfileImage();
            return () => {
                if (lawyerProfileImageUrlRef.current) {
                    URL.revokeObjectURL(lawyerProfileImageUrlRef.current);
                }
            };
        } else {
            setLawyerProfileImageUrl(null);
            lawyerProfileImageUrlRef.current = null;
        }
    }, [selectedLawyer?.profileUrl, editRequestComparisonData?.currentLawyerDetails?.profileUrl, isProfileViewOpen, isEditRequestCompareOpen]);
    useEffect(() => {
        const isLoading = isFetchingRequests || isFetchingLawyerProfile || isFetchingEditRequestCompare || isApproveLoading || isRejectLoading || isFetchingAccountDetails || isFetchingDecryptAccount;
        dispatch(loaderReducer(isLoading));
    }, [dispatch, isFetchingRequests, isFetchingLawyerProfile, isFetchingEditRequestCompare, isApproveLoading, isRejectLoading, isFetchingAccountDetails, isFetchingDecryptAccount]);

    const displayedData = React.useMemo(() => {
        if (!isAccountRequestTab || !requestFilter?.searchTermValue) return requestData;
        const term = requestFilter.searchTermValue.toLowerCase().trim();
        return (requestData || []).filter(item => {
            const lawyerId = (item?.lawyerId || "").toLowerCase();
            const advocateName = `${item?.lawyerDetails?.firstName || ""} ${item?.lawyerDetails?.lastName || ""}`.toLowerCase();
            const hasBankMatch = (item?.bankDetails || []).some(b =>
                (b?.bankName || "").toLowerCase().includes(term) ||
                (b?.accountHolderName || "").toLowerCase().includes(term) ||
                (b?.accountNumber || "").toLowerCase().includes(term) ||
                (b?.ifsc || "").toLowerCase().includes(term)
            );
            const upiStr = (Array.isArray(item?.upiIds) ? item.upiIds.map(u => typeof u === "string" ? u : (u?.upiId || "")).join(" ") : String(item?.upiIds || "")).toLowerCase();
            const hasUpiMatch = upiStr.includes(term);
            return lawyerId.includes(term) || advocateName.includes(term) || hasBankMatch || hasUpiMatch;
        });
    }, [isAccountRequestTab, requestData, requestFilter?.searchTermValue]);

    return (
        <div>
            <div className="flexible" style={{ alignItems: "center" }}>
                <div>
                    <h6 style={{ padding: "10px", margin: 0 }}>{isAccountRequestTab ? "Account Details Request" : isEditRequestTab ? "Edit Request" : "Request"}</h6>
                </div>
                <div className="flexible" style={{ alignItems: "center" }}>
                    <DatePicker
                        picker="month"
                        format="MMM"
                        value={requestFilter?.month || null}
                        onChange={(month) => handleMonthChange(month)}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                    />
                    <UiRangePicker
                        value={requestFilter?.fromDate && requestFilter?.toDate ? [dayjs(requestFilter?.fromDate), dayjs(requestFilter?.toDate)] : null}
                        onChange={(date) => handleDateChange(date)}
                        style={{ borderRadius: "4px" }}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                    />
                    <UiSearch
                        placeholder={keywords?.searchPlaceholder}
                        value={requestFilter?.searchTermValue}
                        style={{ borderRadius: "4px" }}
                        onChange={debounceSearch}
                    />
                </div>
            </div>
            <div className="flexible-end" style={{ padding: "4px 8px 10px 8px" }}>
                {!showCheckbox ? (
                    <UiButton
                        type="primary"
                        onClick={handleRequestLabel}
                    >
                        Request Label
                    </UiButton>
                ) : (
                    <UiButton
                        onClick={handleCancelRequestLabel}
                    >
                        Cancel
                    </UiButton>
                )}
                <UiButton
                    type="primary"
                    disabled={selectedLawyerIds?.length === 0}
                    onClick={handleOpenExcelModal}
                >
                    <img src={downloadReport} alt="" />Download Report in Excel
                </UiButton>
                {!isEditRequestTab && !isAccountRequestTab && <UiButton
                    type="primary"
                    onClick={handleReportDownload}
                    style={{ borderRadius: "4px" }}
                >
                    <img src={downloadReport} alt="" />
                    Download Report
                </UiButton>}
            </div>
            <UiTab tabs={tabData || []} onChange={handleTabChanges} activeTabKey={requestFilter?.activeTabKey} count={totalElements || 0} />
            <div>
                <UiTable
                    dataSource={displayedData}
                    columns={isAccountRequestTab ? ACCOUNT_REQUEST_HEADER_COLUMNS({
                        actionRender: handleAccountApproveClick,
                        handleBankDetails,
                        selectedLawyerIds,
                        handleSelectAll,
                        isAllSelected,
                        isIndeterminate,
                        handleSelectLawyer,
                        showCheckbox
                    }) : LAWYER_REQUEST_HEADER_COLUMNS({
                        actionRender: handleViewProfile,
                        viewDocRender: handleViewDoc,
                        handleBankDetails,
                        selectedLawyerIds,
                        handleSelectAll,
                        isAllSelected,
                        isIndeterminate,
                        handleSelectLawyer,
                        showCheckbox
                    })}
                    scroll={{ y: "calc(100vh - 250px)" }}
                    pagination={requestFilter?.isReportOpen || totalElements <= 10 ? false : {
                        pageSize: requestFilter?.size || 10,
                        current: requestFilter?.page + 1,
                        pageSizeOptions: tablePageSizeOptions,
                        showSizeChanger: true,
                        total: totalElements,
                        onChange: handlePagination
                    }}
                />
            </div>
            <ViewDoc
                isVisible={isViewDocOpen}
                onClose={handleCloseViewDoc}
                documentData={selectedLawyer}
                requestId={selectedLawyer?.requestId || selectedLawyer?.id}
                lawyerName={selectedLawyer?.lawyerName}
                documents={documents}
                setDocuments={setDocuments}
                selectedDocument={selectedDocument}
                setSelectedDocument={setSelectedDocument}
                loading={docLoading}
                setLoading={setDocLoading}
                handleDocumentSelect={handleDocumentSelect}
                handleDownload={handleDownload}
            />
            {isProfileViewOpen && <LawyerProfileView
                isVisible={isProfileViewOpen}
                onClose={handleCloseProfileView}
                lawyerData={selectedLawyer}
                profileImageUrl={lawyerProfileImageUrl}
                isRejectModalOpen={isRejectModalOpen}
                isApproveModalOpen={isApproveModalOpen}
                isProfileReportOpen={isProfileReportOpen}
                reportRef={lawyerProfileReportRef}
                handlePrint={handlePrintLawyerProfile}
                isApproveRejectLoading={isFetchingLawyerProfile}
                reason={reason}
                handleReasonChange={handleReasonChange}
                handleRejectClick={handleRejectClick}
                handleApproveClick={handleApproveClick}
                handleRejectSubmit={handleRejectSubmit}
                handleApproveConfirm={handleApproveConfirm}
                handleCloseRejectModal={handleCloseRejectModal}
                handleCloseApproveModal={handleCloseApproveModal}
                handleDownloadReportClick={handleDownloadReportClick}
                profileModalOpen={profileModalOpen}
                handleProfileModalOpen={handleProfileModalOpen}
                handleProfileModalClose={handleProfileModalClose}
            />}
            {isEditRequestCompareOpen && <EditRequestCompareDrawer
                isVisible={isEditRequestCompareOpen}
                onClose={handleCloseEditRequestCompare}
                currentLawyerDetails={editRequestComparisonData?.currentLawyerDetails}
                requestedLawyerDetails={editRequestComparisonData?.requestedLawyerDetails}
                editableRequestFields={LAWYER_EDITABLE_FIELDS}
                profileImageUrl={lawyerProfileImageUrl}
                profileModalOpen={profileModalOpen}
                handleProfileModalOpen={handleProfileModalOpen}
                handleProfileModalClose={handleProfileModalClose}
                isApproveRejectLoading={isFetchingEditRequestCompare}
                isRejectModalOpen={isRejectModalOpen}
                isApproveModalOpen={isApproveModalOpen}
                reason={reason}
                handleReasonChange={handleReasonChange}
                handleRejectClick={handleRejectClick}
                handleApproveClick={handleApproveClick}
                handleRejectSubmit={handleRejectSubmit}
                handleApproveConfirm={handleApproveConfirm}
                handleCloseRejectModal={handleCloseRejectModal}
                handleCloseApproveModal={handleCloseApproveModal}
            />}
            <BankDetailsModal
                open={bankDetailsModal?.open}
                onClose={handleBankDetailsClose}
                bankDetails={bankDetailsModal?.data}
                loading={bankDetailsModal?.loading}
            />
            <ApproveAccountModal
                isVisible={accountApproveModal?.open}
                onClose={handleAccountApproveClose}
                onConfirm={handleAccountApproveConfirm}
                isLoading={accountApproveModal?.loading}
                record={accountApproveModal?.record}
            />
            <div style={{ display: "none" }}>
                <PrintAllRequestReport
                    ref={reportRef}
                    data={requestData}
                    date={{ fromDate: requestFilter?.fromDate, toDate: requestFilter?.toDate }}
                    selectedMonth={requestFilter?.month}
                    selectedMonthString={selectedMonthString}
                />
            </div>
            <SubmerchantModal
                open={isSubmerchantModalOpen}
                onClose={() => setIsSubmerchantModalOpen(false)}
                onConfirm={handleDownloadExcelReport}
                selectedRecords={selectedLawyerIds.map(id => {
                    return selectedLawyerRecords.find(item => (item?.lawyerId || item?.id || item?.requestId) === id)
                        || requestData.find(item => (item?.lawyerId || item?.id || item?.requestId) === id)
                        || { id };
                })}
                toEmailAddress={toemailaddress}
                ccEmailAddress={ccemailaddress}
            />
        </div>
    );
};
export default Requests;